<div class="import-layer-map-preview">
  <div
    #mapContainer
    class="import-layer-map-preview__map"
    role="img"
    aria-label="Náhled importovaných vrstev na mapě"
  ></div>
  <p *ngIf="isBuildingPreview" class="import-layer-map-preview__hint text-xs text-neutral-500 dark:text-neutral-400">
    Připravuji náhled mapy…
  </p>
  <p *ngIf="unavailableReason" class="import-layer-map-preview__hint text-xs text-neutral-500 dark:text-neutral-400">
    {{ unavailableReason }}
  </p>
  <p *ngIf="hasGeometry && truncated" class="import-layer-map-preview__hint text-xs text-neutral-500 dark:text-neutral-400">
    Náhled zobrazuje jen část prvků (výkon). Import použije celý soubor.
  </p>
</div>
